import React, { useState, useEffect, Suspense } from 'react';
import { Link } from 'react-router-dom';
import Engineer from '../components/Engineer';
import { Canvas } from '@react-three/fiber';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useStickyState } from "../hooks/useStickyState";

const Home = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [nextUserName, setNextUserName] = useStickyState("nextUserName", "");
  const [username, setUsername] = useStickyState("username", "");
  const [userInfo, setUserInfo] = useState(null);
  const [zone] = useState("DK1");
  const [message, setMessage] = useState("");

  const auth = getAuth();
  const firestore = getFirestore();

  // Recupero info utente e controllo admin
  useEffect(() => {
    // auth + claims + self registration doc
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setUserInfo(null);
        setIsAdmin(false);
        return;
      }

      try {
        const regRef = doc(firestore, 'registrations', user.uid);
        const regSnap = await getDoc(regRef);
        const data = regSnap.exists() ? regSnap.data() : null;

        setUserInfo(data);
        setIsAdmin(!!data?.isAdmin);
        if (data?.username) setUsername(data.username);
      } catch (e) {
        console.error('Read registration error:', e);
        setUserInfo(null);
        setIsAdmin(false);
      }
    });

    return () => unsub();
  }, [auth, firestore]);

  const handleInputChange = (e) => {
    setNextUserName(e.target.value);
  };

  const handleSetUserName = () => {
    setMessage("");
    if (!!nextUserName) {
      localStorage.setItem("nextUserName", nextUserName);
      localStorage.setItem("username", JSON.stringify(nextUserName));
      setMessage("Next username set!");
      setUsername(nextUserName);
    }
  };

  useEffect(() => {
    localStorage.setItem('zone', zone);
  }, [zone]);

  return (
    <div className="background">
      <div className="line-overlay"></div>
      <div className="left-content slide-in-left-transition">
        {isAdmin && (
          <div
            style={{
              zIndex: 100,
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              marginBottom: "25px",
              transform: "rotate(-3deg)",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {message && (
              <p
                style={{ fontWeight: "bold", color: "#4cb944", margin: "0px" }}
              >
                {message}
              </p>
            )}
            <input
              type="text"
              className="admin-input"
              placeholder="Enter username"
              value={nextUserName}
              onChange={handleInputChange}
            />
            <button onClick={handleSetUserName} className="admin-button">
              Set next player
            </button>
          </div>
        )}

        <img
          src="/neonlogo.png"
          alt="Price level"
          style={{ width: "320px", transform: "rotate(-9deg)" }}
        />

        <div className="intro-container">
          <div className="intro-buttons">
            <Link to="/game" className="intro-button">
              PLAY
            </Link>
            {/* <div className="intro-button">
            <Link
              to="/game"
              onClick={() => localStorage.setItem('guestMode', 'true')}
            >
              PLAY AS GUEST
            </Link>
          </div> */}
            <Link to="/about" className="intro-button">
              ABOUT
            </Link>
          </div>
          <Link to="/leaderboard">
            <img
              src="/Leaderboard.png"
              alt="Price level"
              style={{
                width: "195px",
              }}
            />
          </Link>
        </div>
      </div>

      {/* Sezione info utente con il pulsante Logout */}
      {userInfo && (
        <div
          className="user-info"
          style={{
            position: "absolute",
            top: "45px",
            left: "50px",
            zIndex: 10001,
            background: "rgba(0, 0, 0, 0.5)",
            padding: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            borderRadius: "8px",
            color: "#eef6ff",
            fontSize: "16px",
          }}
        >
          <div className="profile-icon"></div>
          <p>Username: {userInfo.username ?? username}</p>
          {!!userInfo.records && <p>Records: {userInfo.records}</p>}
          <button
            onClick={async () => {
              await signOut(auth);
              localStorage.removeItem("guestMode");
              localStorage.removeItem("nextUserName");
              window.location.reload();
            }}
            style={{
              marginTop: "10px",
              padding: "5px 10px",
              background: "#b80C09",
              color: "#eef6ff",
              border: "none",
              borderRadius: "4px",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Logout
          </button>
        </div>
      )}

      {/* Modal di selezione zona */}

      {/* <LoopingGraph /> */}

      {/* <div className="vignette-overlay" /> */}

      <nav>
        <Canvas
          style={{
            width: "100vw",
            height: "100vw",
            position: "absolute",
            top: "0",
          }}
        >
          <Suspense fallback={null}>
            <ambientLight />
            <Engineer />
            <directionalLight
              castShadow
              position={[5, 15, 10]}
              intensity={1.5}
              shadow-mapSize-width={256}
              shadow-mapSize-height={256}
              shadow-camera-near={1}
              shadow-camera-far={50}
              shadow-camera-left={-10}
              shadow-camera-right={10}
              shadow-camera-top={10}
              shadow-camera-bottom={-10}
            />
          </Suspense>
        </Canvas>
      </nav>
    </div>
  );
};

export default Home;
